import './api';
import './handlers';
import './subs';
import { registerPopup } from '@/ui/popupRegistrar';
import React from 'react';
import AutoCashinDialog from '@/cashins/views/AutoCashinDialog';
import CashinPaidOut from '@/cashins/views/popup/CashinPaidOut';
import Dialog from '@/ui/dialogs/Dialog';

registerPopup('cashin/auto-cashin-dialog', popup => <AutoCashinDialog {...popup.get('data')} />);
registerPopup('cashin/cashin-paidOut-dialog', popup => (
    <Dialog className={'success'} modal>
        <CashinPaidOut {...popup.get('data')} />
    </Dialog>
));
